import React from 'react';
import { useApolloClient } from '@apollo/client';

import { useDefaultedCurrencyFromURL } from 'utils/hooks/currency';
import { userShape, bookingShape } from 'constants/propTypes';

import { withUser } from 'components/queries/GetUserQuery';

import ExchangeDetails from './ExchangeDetails';

const Index = (props) => {
  const client = useApolloClient();
  const { user, booking } = props;
  const [currency, changeCurrency] = useDefaultedCurrencyFromURL({
    availableCurrencies: user.paymentCurrencies,
    defaultCurrency: booking.currency,
    isMultiCurrency: booking.isMultiCurrency
  });

  return <ExchangeDetails {...props} client={client} exchangeCurrency={currency} changeCurrency={changeCurrency} />;
};

Index.propTypes = {
  user: userShape,
  booking: bookingShape
};

export default withUser(Index);
